import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Router, ActivatedRoute } from "@angular/router";
import { ApplicationService } from "app/services/application.service";
import { AuthWebService } from "app/services/authweb.service";
import { CarrierService } from "app/services/carrier.service";
import { PermitService } from "app/services/permit.service";
import { UtilityServiceService } from "app/services/utility-service.service";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { CurrencyFormat } from "app/pipes/currencyFormat.pipe";
import { WorkflowService } from "app/services/workflow.service";
import { PopupService } from "app/services/shared/popup.service";
import { ConfirmDialogService } from "app/services/shared/confirm-dialog/confirm-dialog.service";
import { ProcessActivityDTO } from "../../models/processactivitydto";
import { DatePipe } from "@angular/common";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ModalDirective } from "ngx-bootstrap/modal";
import { BsModalRef } from "ngx-bootstrap/modal";
import { environment } from "environments/environment";
import { AdminAnnualComplianceService } from "app/admin-annual-compliance/service/admin-annual-compliance.service";
import { AnnualComplianceService } from "app/annual-compliance/service/annual-compliance.service";


@Component({
  selector: "app-process",
  templateUrl: "./process.component.html",
  styleUrls: ["./process.component.scss"],
  providers: [CurrencyFormat],
})
export class ProcessComponent implements OnInit {
  @Input("dataCntrl") dataCntrl: any;

  carrierApproval: boolean = false;
  permitApproval: boolean = false;

  application_id: any;
  role_id: any;
  activity_id: any;
  app_type: string;

  loggedInUser: any;
  users_name:any;
  role:any;

  show_assigned_user_message: boolean = false;
  actions: any = [];
  selectedAction: string = "";
  selected_action_id: number = 0;

  isLoading: boolean = false;
  message = "Loading application, please wait...";
  canload: boolean = false;

  processForm: FormGroup;
  txtarea_rows: number = 3;

  roleUsers: any = [];
  activityDTO = new ProcessActivityDTO();
  comment: any = '';
  isfinalapproval: boolean = false;
  requestmoreinfo: boolean = false;
  external_approval: boolean = false;
  ready_for_gazzette:boolean = false;
  permitMFA:any
  aUser: string = "";
  balanceDetails: any;

  modaltext: string;
  callback: string;
  ismandatory: boolean;

  public modalRef: BsModalRef;
  //@ViewChild("childModal", { static: true }) childModal: ModalDirective;

  //#region newUI
  actioncheck:string = "";
  selectedcomment:any = '';
  showCommentBox: boolean = false;
  hascomment: boolean = false;
  //#endregion

  constructor(
    private workflowService: WorkflowService,
    private carrierService: CarrierService,
    private applicationService: ApplicationService,
    private permitService: PermitService,
    private AdminAnnualComplianceService: AdminAnnualComplianceService,
    private annualComplianceService: AnnualComplianceService,
    private formBuilder: FormBuilder,
    private authWebService: AuthWebService,
    public utility: UtilityServiceService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private toaster: ToastNotificationService,
    private showModal: PopupService,
    private dialog: ConfirmDialogService,
    private pipe: DatePipe,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.users_name = this.authWebService.userInfo().username;
    this.aUser = environment.authWebApi.userData.User.FirstName;
    this.loggedInUser = this.authWebService.userData.User;
    this.permitMFA= environment.authWebApi.systemData.Configurations.find(p => p.Code == 'PermitMFA').Value;
    this.role = this.authWebService.userData.Roles.find(p=>p.IsWorkflowRole==true);

    this.isLoading = true;

    this.app_type = this.dataCntrl.app_type;
    this.initForm();
    this.onInitActions(this.dataCntrl.role_id, this.dataCntrl.activity_id);
    this.getActivity(this.dataCntrl.activity_id);
    this.getUserInRole(this.dataCntrl.role_id);
    if(this.dataCntrl.application.status_id == 34 && this.role.Code=='ADJUDICATING_LAA'){
      this.ready_for_gazzette = true;
    }
  }

  initForm() {
    this.processForm = this.formBuilder.group({
      EmailAddress: [
        "",
        [
          <any>Validators.required,
          Validators.pattern(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ),
        ],
      ],
    });
  }

  //#region Actions
    onInitActions(role_id: number, activity_id: number) {
      this.workflowService.getActionsByRole(role_id, activity_id).subscribe(
        (result) => {
          this.actions = result;
          this.actions = this.actions.filter(x => !x.name.includes('Submitted'))
        },
        (error) => {
          console.log(error);
        }
      );
    }
  
    actionChange() {
      console.log(this.selectedAction)
      console.log(this.selected_action_id)
      this.selected_action_id = this.actions.find(
        (p) => p.name == this.selectedAction
      ).id;
      if (this.selectedAction == "External Approval") {
        this.external_approval = true;
      }

      console.log(this.selectedAction)
      console.log(this.selected_action_id)

    }

    actionChanged(action:string){

    }
  //#endregion

  //#region Activity
    getUserInRole(role_id: number) {}
  
    getActivity(activity_id: number) {
      this.isLoading = true;
      this.workflowService.getActivity(activity_id).subscribe(
        (result) => {
          this.dataCntrl.taskData = result;
          if (this.dataCntrl.taskData.userAssigned != this.loggedInUser.UserName) {
            this.show_assigned_user_message = true;
          }
          this.canload = true;
          this.isLoading = false;
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
        }
      );
    }
  //#endregion

  //#region OnProcessActivity
/*     onProceed() {
      switch (this.selectedAction) {
        case "Send Forward": {
          this.modaltext = "Please provide comment or click 'No Comment' to proceed without a comment";
          this.callback = "send forward";
          this.ismandatory = false;
          this.childModal.show();
  
          break;
        }
        case "Send Back": {
  
          this.modaltext = "Please provide comments to send back. Comment is mandatory";
          this.callback = "send back";
          this.ismandatory = true;
          this.childModal.show();
  
          break;
        }
        case "Approve": {
  
          this.modaltext = "Please provide comment or click 'No Comment' to proceed without a comment";
          this.callback = "approve";
          this.ismandatory = false;
          this.isfinalapproval = true;
          this.childModal.show();
          
          break;
        }
        case "Reject": {
  
          this.modaltext = "Please provide reason for rejection. Reason is mandatory";
          this.callback = "reject";
          this.ismandatory = true;
          this.isfinalapproval = true
          this.childModal.show();
         
          break;
        }
        case "External Approval": {
  
          this.modaltext = "Please provide comment(s) for external approval. Comments are mandatory";
          this.callback = "send for external approval";
          this.ismandatory = true;
          this.childModal.show();
  
          break;
        }
        case "Request More Info": {
  
          this.modaltext = "Please provide comment for information required. Comments are mandatory";
          this.callback = "request more info";
          this.ismandatory = true;
          this.requestmoreinfo = true;
          this.childModal.show();
        
          break;
        }
        default: {
          console.log("Nothing to do");
          break;
        }
      }
    } */
  
    setActivityData() {
      this.activityDTO.Activityid = this.dataCntrl.taskData.id;
      this.activityDTO.Rolefromid = this.dataCntrl.taskData.roleAssignedId;
      this.activityDTO.Userfrom = this.dataCntrl.taskData.userAssigned;
      this.activityDTO.Actionid = this.selected_action_id;
      this.activityDTO.Actionuser = this.loggedInUser.UserName;
      this.activityDTO.Comment =
        this.selectedcomment != ""
          ? `${this.loggedInUser.UserName} (${this.pipe.transform(
              new Date(),
              "yyyy-MM-dd h:mm a"
            )}) : ` + this.selectedcomment
          : "";
      this.activityDTO.Isfinalapproval = this.isfinalapproval;
      this.activityDTO.RequiresMoreInfo = this.requestmoreinfo;
    }
  
 /*    action(resp, selectedcomment, callback) {
      if(this.ismandatory==true && selectedcomment==''){
        this.toaster.error(
          "Please provide a comment to proceed",
          "Confirmation"
        );
        return;
      }

      if (resp != null) {
        this.selectedcomment = selectedcomment;
        this.setActivityData();
        this.complete(callback);
      } else if (resp == null) {
        this.selectedcomment = '';
        //this.childModal.hide();
      }
    } */
  
    complete(actionname) {
      //this.childModal.hide();
      this.dialog.confirmThis(`Are you sure you want to ${actionname}. Once you proceed, you cannot change the selected action.`,
      () => {
        this.isLoading = true;
        if(this.activityDTO.Isfinalapproval){
          switch (this.app_type){
          case 'carrier':
            this.approveCarrier();
            break;
          case 'permit':
            this.approvePermit();
            break;
          case 'compliance':
            this.approveCompliance(actionname);
            break;
          };
        } else if(this.app_type == 'compliance'){
          this.approveCompliance(actionname);
        } else{
          this.progressWorkflow("Activity successfully completed");
        }
      },
      () => {
        console.log(this.comment)
        return;
      }
    );
    }
  
    progressWorkflow(successmessage:string){    
      this.workflowService
        .processActivity(this.activityDTO, this.app_type)
        .subscribe(
          (resp) => {
            if (resp) {
              this.onSetGazzetting();
              if(successmessage != '---none---'){
                this.toaster.success(
                  successmessage,
                  "Confirmation"
                );
                this.router.navigate(["/workflow/myinbox"]);
              }
            } else {
              this.isLoading = false;
              if(successmessage != '---none---'){
              this.toaster.error(
                "Activity completion failed",
                "Confirmation"
              );
            }
            }
            this.isLoading = false;
          },
          (error) => {
            console.log(error);
            this.toaster.error(
              `An error occured. Please try again, if the error persists, please contact support`,
              "Confirmation"
            );
            this.isLoading = false;
          }
  
        ); 
    }

  //#region CarrierApproval
    approveCarrier(){
  
      if(this.utility.carrierObject.data.status_id === 93){
        this.isLoading = false;
        return this.toaster.error('Account already rejected!','Confirmation');
       }
  
       if(this.utility.carrierObject.data.status_id === 999){
        this.isLoading = false;
        return this.toaster.error('Cannot approve inactive account!','Confirmation');
       }
  
      if(this.utility.carrierObject.data.status_id === 51){
        this.isLoading = false;
       return this.toaster.error('Account already approved!','Confirmation');
      }
  
      this.isLoading = true;
          this.carrierService.approveAccountAndSendNotification(this.utility.carrierId, this.users_name).subscribe((resp:any) => {
            if (resp.IsSent) {
              let message = `Carrier account ${this.utility.carrierName} approved and notification will be sent shortly.`;
              this.progressWorkflow(message);
            }
            else
              this.toaster.error("A problem occured while processing your request. Please try again later.", "Approve Carrier Account");
            this.isLoading = false;
          }, error => {
            this.isLoading = false;
          });
    }
  //#endregion

  //#region PermitApproval
    approvePermit(){
        let permit_status_id: any = this.utility.permitStatusId;
        let carrier_status_id= this.dataCntrl.carrier.status_id;
    
        if(permit_status_id === 51){
          this.toaster.error('Permit already approved!','Confirmation');
          this.isLoading = false;
          return false;
        }
        if(carrier_status_id < 51){
          this.toaster.error('You may not approve the application as the carrier is not approved.','Confirmation');
          this.isLoading = false;
          return false;
        }
    
        if(carrier_status_id >= 91){
          this.toaster.error('You may not approve the application as the carrier is rejected or non-compliant.','Confirmation');
          this.isLoading = false;
          return false;
        }
    
        if (permit_status_id !== 11){
          console.log(permit_status_id)
          this.toaster.error(`Only applications in "Submitted" status can be approved.`, `Confirmation`);
          this.isLoading = false;
          return false;
        }    
        
        if ((permit_status_id == 11 || permit_status_id == 74)) {
          this.isLoading = true;
          this.applicationService.getById(this.utility.permitAppId).subscribe((app:any) => {
            if (app.vehicle.length != 0) {              
              this.onApprovePermit();
            }
            else {
              this.toaster.error('A permit may not be approved without a vehicle.', `Confirmation`);
              this.isLoading = false;
            }       
          } , error  => {
            this.isLoading = false;
          });      
        }
    }
    
    onApprovePermit(){
        if ((this.utility.carrierId > 0) && (this.utility.permitAppId > 0)) {
          this.EnvokeOTP();
        } else {
          this.isLoading = false;
          this.toaster.error("A problem occured while processing your request. Please try again later.", "Confirmation");
        }
    }
    
    EnvokeOTP(){    
    
        if (this.permitMFA == "true") {
          let OtpMessage = document.getElementById("OtpMessage");
          this.isLoading = true;
          let userObj = Object.create(this.loggedInUser);
          userObj.Id = this.loggedInUser.Id;
          userObj.EmailAddress = this.loggedInUser.EmailAddress;
          userObj.MobileNumber = this.loggedInUser.MobileNumber;
          userObj.DialCodeMobile = this.loggedInUser.DialCodeMobile;
          userObj.CommunicationType = this.loggedInUser.CommunicationType;
          userObj.SysCode = "ICBMS";
    
          if (userObj.CommunicationType == "SMS") {
            OtpMessage.innerHTML =
              "We have sent the verification code to your mobile number.";
          } else {
            OtpMessage.innerHTML =
              "We have sent the verification code to your email address.";
          }
    
          this.authWebService
            .webrequest("POST", "UserService", "RequestOtp", userObj)
            .then(
              (data) => {
                if (data == true) {
                  //show otp pop up
                  document.getElementById("secretButton").click();
                  this.isLoading = false;
                }
              },
              (error) => {
                this.isLoading = false;
              }
            );
        } else {
            this.canContinue();
        }
    }
    
    verifyOtp(){
      const OtpCode = document.getElementById('OTPCode') as HTMLInputElement | null;
      let Otp = OtpCode.value;
    
      this.message = "Verifying OTP. Please wait...";
      this.isLoading = true;
      
      this.loggedInUser.Otp = Otp;
    
      let userObj = Object.create(this.loggedInUser);
      userObj.Id = this.loggedInUser.Id;
      userObj.EmailAddress =  this.loggedInUser.EmailAddress;
      userObj.MobileNumber = this.loggedInUser.MobileNumber;
      userObj.DialCodeMobile = this.loggedInUser.DialCodeMobile;
      userObj.CommunicationType = this.loggedInUser.CommunicationType;
      userObj.SysCode = "ICBMS";
      userObj.Otp = Otp;
    
      this.authWebService.webrequest('POST','UserService', 'ValidateOtp', JSON.stringify(userObj)).then((ur) => {
        this.canContinue();
      }, (error) => {
        this.isLoading = false;
        this.toaster.error('Invalid OTP', 'OTP could not verified');
      });  
    }
    
    getUpdateBalance() {    
        this.carrierService.getById(this.utility.carrierId).subscribe((carr:any) => {
          if(carr != null && carr != undefined)
          {
            this.carrierService.getUpdateBalance(carr.carrier_account_id).subscribe(res => {});
          }
      });
    }

    canContinue(){
      this.getUpdateBalance();
    
      this.message = "Processing approval. Please wait...";
      this.isLoading = true;
    
      this.permitService.approvePermitAndSendNotification(this.utility.carrierId,this.utility.permitAppId,this.users_name)
        .subscribe(
          (resp: any) => {
            if (resp.IsSent && resp.InvoiceCreated) {
              this.progressWorkflow("---none---");
              this.dialog.confirmThis(`Permit approved successfully. Notification will be sent shortly. Would you like to Print this permit?`,
                () => {
                  this.isLoading = false;
                  this.getUpdateBalance();
                  this.router.navigateByUrl(`/permit/approval/printing/${this.utility.permitAppId}/true`
                  );
                },
                () => {
                  this.isLoading = false;
                  this.router.navigate(["/workflow/myinbox"]);
                }
              );
            } else if (!resp.IsSent) {
              if (resp.Message == "InsufficientBalance") {
                this.isLoading = false;
                this.toaster.error("The Carrier has an insufficient balance in their account, you cannot proceed to approve this permit application.",'Confirmation');
              } else if (resp.Message == "ZeroBalance") {
                this.isLoading = false;
                this.toaster.error("The Carrier does not have sufficient funds in their account, you cannot proceed to approve this permit application.",'Confirmation');
              } else {
                this.isLoading = false;
                this.toaster.error(resp.Message, 'Confirmation');
              }
            } else if (!resp.InvoiceCreated) {
              this.isLoading = false;
              this.toaster.error(resp.Message + "; \n Please notify the administrator!",'Confirmation');
            } else{
              this.toaster.error(`A problem occured while processing your request. Please try again later. ${resp.Message}`,'Confirmation');
              this.isLoading = false;
            }          
          },
          (error) => {
            this.isLoading = false;
          }
        );
    }

    async onSetGazzetting(){
      let worfklowgroupid = this.dataCntrl.permittype.workflow_group_id;
      let statusid = 31;
      //group id 4 is all long term permits
      if(worfklowgroupid==4){
        if(this.dataCntrl.application.status_id == 11){
          this.dataCntrl.application.status_id = 34;
        }

        const data = await this.applicationService.putApplication(this.dataCntrl.application).toPromise();
        console.log(data)
      }
    }
  //#endregion

  //#region ComplianceApproval
    approveCompliance(actionname:string){
      switch (actionname){
        case 'approve':
          this.onApproveCompliance();
          break;
        case 'reject':
          this.onRejectCompliance();          
          break;
        case 'request more info':
          this.onRequestMoreInfo();
          break;
        };
    }
    
    async onRejectCompliance() {
      this.isLoading = true;

      const data = await this.AdminAnnualComplianceService.onRejectStatus(this.dataCntrl.compliance_id ,this.aUser).toPromise();
      if (data['Result']  == true) {
        this.progressWorkflow('---none---');
        this.router.navigate([`/admin-annual-compliance/application/${this.dataCntrl.compliance_id}`,]);
      } else {
        this.isLoading = false;
        this.toaster.success('Failed to process your request. Please try again',"Compliance Certificate");
      }
    }
  
    async onApproveCompliance() {
      this.isLoading = true;

      this.carrierService.checkIfComplianceCanBePaidFor(this.dataCntrl.compliance_id).subscribe((result: any) => {

        if(result == null){
          this.toaster.error("The carrier account could not found in sage, please contact the administrator", "Sage Account");
          return;
        }
      
        if (result.AccountBalance == null || result.AccountBalance == 0) {
          this.annualComplianceService.SendEmailWithNoFunds(this.dataCntrl.compliance_id, this.aUser).subscribe((result: any) => { 
          });
          this.toaster.error("The carrier account does not have enough funds. The carrier has been sent an email", "Insufficient Funds");
          return;
        }
    
        result.AccountBalance = result.AccountBalance * -1;
        this.annualComplianceService.getCompliancesAmountsToBePaid(this.dataCntrl.compliance_id).subscribe(
          async (response) => {
            this.balanceDetails = response;
            if(this.dataCntrl.Is_duplicate){
              let Bal = 0;
              Bal = this.balanceDetails.duplicate_fee ?? 0 + this.balanceDetails.line_total ?? 0;
              if (Bal > result.AccountBalance ?? 0){
                this.annualComplianceService.SendEmailWithNoFunds(this.dataCntrl.compliance_id, this.aUser).subscribe((result: any) => { 
                }); 
                this.toaster.error("Duplicate fee is greater than account balance. The carrier has been sent an email", "Insufficient Funds");
                return
              }
  
            }
            else{
              if ((this.balanceDetails.line_total ?? 0) > result.AccountBalance ?? 0){
                this.annualComplianceService.SendEmailWithNoFunds(this.dataCntrl.compliance_id, this.aUser).subscribe((result: any) => { 
                });
                this.toaster.error("Application fee is greater than account balance. The carrier has been sent an email", "Insufficient Funds");
                 return
              }
  
            }

            const data = await this.AdminAnnualComplianceService.onApprovedStatus(this.dataCntrl.compliance_id, this.dataCntrl.Is_duplicate , this.aUser).toPromise();
            if (data['Result'] == true) {
              this.progressWorkflow('---none---'); 
              this.toaster.success('Compliance certificate successfully approved',"Compliance Certificate");
              this.router.navigate([`/admin-annual-compliance/application/${this.dataCntrl.compliance_id}`]);
            } else {
              this.isLoading = false;
              this.toaster.success('Failed to process your request. Please try again',"Compliance Certificate");
            }

        },
        () => {
          return false;
        });
      },
      error => {
        // Handle error from getCompliancesAmountsToBePaid if necessary
      });
    }
  
    async onRequestMoreInfo() {

      this.isLoading = true;
      const data = await this.AdminAnnualComplianceService.onHoldStatus(this.dataCntrl.compliance_id ,this.aUser).toPromise();
      console.log(data)
      if (data == true) {
        this.progressWorkflow('Compliance certificate successfully put on hold');
      } else {
        this.isLoading = false;
        this.toaster.success('Failed to process your on hold request. Please try again',"Compliance Certificate");
      }
    }
  //#endregion

//#endregion

  onCancel() {
   this.router.navigate(["/workflow/myinbox"]);
  }

  //#region newUI

  onProceed() {
    switch (this.selectedAction) {
      case "Send Forward": {
        this.callback = "send forward";
        this.action("send forward");
        break;
      }
      case "Send Back": {
        this.callback = "send back";
        this.action("send back");
        break;
      }
      case "Approve": {
        this.isfinalapproval = true;        
        this.callback = "approve";
        this.action("approve");
        break;
      }
      case "Reject": {
        this.isfinalapproval = true
        this.callback = "reject";
        this.action("reject");      
        break;
      }
      case "External Approval": {
        this.callback = "send for external approval";
        this.action("send for external approval");    
        break;
      }
      case "Request More Info": {
        this.requestmoreinfo = true;
        this.callback = "request more info";
        this.action("request more info");    
        break;
      }
      default: {
        console.log("Nothing to do");
        break;
      }
    }
  }

      action(callback) {
      if(this.ismandatory==true && this.selectedcomment==''){
        this.toaster.error(
          "Please provide a comment to proceed",
          "Confirmation"
        );
        return;
      }
      
      this.setActivityData();
      this.complete(callback);
    }

  hasAction(action){
    const obj = this.actions.find((p) => p.name == action);
    if(obj){
      return true;
    }else{
      return false;
    }
  }

  onActionChecked(action:string){
    this.selectedAction = action;
    const obj = this.actions.find((p) => p.name == action);
    if(obj){
      this.selected_action_id = obj.id;
    }

    switch (action) {
      case "Send Forward": {
        this.ismandatory = false;
        this.hascomment = true;
        break;
      }
      case "Send Back": {
        this.ismandatory = true;
        this.hascomment = false;
        break;
      }
      case "Approve": {
        this.ismandatory = false; 
        this.hascomment = true;      
        break;
      }
      case "Reject": {
        this.ismandatory = true; 
        this.hascomment = false;      
        break;
      }
      case "External Approval": {
        this.ismandatory = true;
        this.hascomment = false;
        break;
      }
      case "Request More Info": {
        this.ismandatory = true; 
        this.hascomment = false;     
        break;
      }
      default: {
        this.ismandatory = false; 
        this.hascomment = false;
        break;
      }
    }
  }

  onCommentSelected(){
    if(this.selectedcomment=='Other'){
      this.showCommentBox = true;
      this.selectedcomment = '';
      this.hascomment = false;
    }else{
      this.showCommentBox = false;
      this.hascomment = true;
    }
  }

  onCommentBlur(){
    if(this.selectedcomment.length > 5){
      this.hascomment = true;
    }
  }
  //#endregion

}
